export enum SituacaoContratoEnum {
    SITUACAO_EM_DIA = 'SITUACAO_EM_DIA',
    SITUACAO_EM_ATRASO = 'SITUACAO_EM_ATRASO',
    SITUACAO_AGUARDANDO_PAGAMENTO = 'SITUACAO_AGUARDANDO_PAGAMENTO'
}
